/**
 * A captura da tela que a pessoa via — spec 0108, DD-23.
 *
 * Tirada ANTES de a gaveta abrir, para a gaveta não sair na foto. Desenha o
 * DOM até o fim da área visível e recorta só o que estava na janela: é o que
 * a pessoa viu, e não a página inteira (uma lista de 500 linhas levaria
 * segundos e megabytes). Reduzida a 1600 px de largura e salva em JPEG.
 *
 * Imagem de outra origem e `iframe` (o PDF do documento) saem em branco: a
 * captura é contexto, não prova.
 */
import { domToCanvas } from 'modern-screenshot';

const LARGURA_MAXIMA = 1600;
const PRAZO_MS = 6000;

export async function capturarTela(): Promise<Blob | null> {
  const corpo = document.body;
  const fundo = getComputedStyle(corpo).backgroundColor;
  const escala = Math.min(1, LARGURA_MAXIMA / window.innerWidth);
  const topo = window.scrollY;
  const altura = window.innerHeight;

  const desenho = domToCanvas(corpo, {
    width: window.innerWidth,
    height: Math.min(corpo.scrollHeight, topo + altura),
    scale: escala,
    backgroundColor: fundo,
    // O que se marca para ficar fora da foto (o próprio botão, por exemplo).
    filter: (no) => !(no instanceof HTMLElement && no.dataset.semCaptura !== undefined),
  });
  const prazo = new Promise<null>((resolve) => setTimeout(() => resolve(null), PRAZO_MS));
  const tela = await Promise.race([desenho, prazo]);
  if (!tela) return null;

  // Recorta a janela visível do desenho que vai do topo da página até ela.
  const recorte = document.createElement('canvas');
  recorte.width = Math.round(window.innerWidth * escala);
  recorte.height = Math.round(altura * escala);
  const ctx = recorte.getContext('2d');
  if (!ctx) return null;
  ctx.drawImage(tela, 0, Math.round(topo * escala), recorte.width, recorte.height, 0, 0, recorte.width, recorte.height);
  return new Promise((resolve) => recorte.toBlob((b) => resolve(b), 'image/jpeg', 0.8));
}
